export default [
  {
    header: 'Игроки',
  },
  {
    title: 'Рейтинг',
    route: 'players-rating',
    icon: 'AwardIcon',
  },
]
